import "../orchestration/reloadMailRibbonConfigurationOrchestrator";
import loadMailRibbonConfigurationForAccount from "./loadMailRibbonConfigurationForAccount";
import { OnlyMailStateChanges, RegisterForAccountStateChange } from "owa-account-source-list";
import { getGlobalSettingsAccountMailboxInfo, type AccountSource, } from "owa-account-source-list-store";

/**
 * Load the appropriate mail ribbon configuration for all of the user's accounts
 */
export default function loadMailRibbonConfiguration(): void {
    loadMailRibbonConfigurationForAccount(getGlobalSettingsAccountMailboxInfo());
    // Use the RegisterForAccountStateChange to be called for all accounts that are pre-render complete
    // either now or in the future
    RegisterForAccountStateChange((accountSource: AccountSource) => {
        loadMailRibbonConfigurationForAccount(accountSource.mailboxInfo);
    }, (_accountSource: AccountSource) => { }, // no-op the pre-account removed callback
    OnlyMailStateChanges);
}
